import { Button, Modal } from "@closer/ui";

/**
 * AKIŞ İPTALİ ONAY DİYALOĞU (CLOS-233 `[170]` · alt görev CLOS-968).
 *
 * ### ⚠ Neden onay isteniyor
 *
 * İptal GERİ ALINAMAZ: akış kapanıyor, açık görevlerin sorumluluğu düşüyor ve süreç ancak
 * BAŞTAN başlatılarak devam edebiliyor. Dört bölümde de (inceleme, onay, mutabakat, imza)
 * düğme bugüne kadar tek tıkla, hiçbir soru sormadan isteği gönderiyordu; sözleşme
 * ekranında "İptal et" düğmesi, kararı okuyan bir kişinin yanına düşen "Karar ver"
 * düğmesiyle yan yana duruyor. Yanlışlıkla dokunanın geri dönüşü yoktu.
 *
 * ### ⚠ Neden gerekçe alanı YOK
 *
 * `config/workflowCancelReassign.json` gerekçe zorunluluğunu tür başına tanımlıyor, ama o
 * politika GÖREV seviyesindeki iptal ve yeniden atama uçlarına ait. Buradaki dört uç
 * (`.../cancel`) AKIŞ seviyesinde ve GÖVDE ALMIYOR — `validate({ params: ... })`, body
 * şeması yok. Ekrana bir gerekçe kutusu koyup göndermemek ya da göndermek üzere sunucunun
 * sessizce yok saymasına bırakmak, kullanıcıya kaydedilmeyen bir şeyi kaydettirmek olurdu.
 * Gerekçe bir gün akış seviyesinde de istenecekse önce uç onu kabul etmeli.
 *
 * ### ⚠ Neden ortak bileşen
 *
 * Dört bölüm de aynı kararı veriyor. Ayrı ayrı yazılsalardı onay metni ya da düğme dili
 * bir gün birinde değişir, ötekilerde kalırdı.
 */
export interface WorkflowCancelDialogProps {
  open: boolean;
  onClose: () => void;
  /** Hangi akışın iptal edildiği başlıkta açıkça yazar. */
  title: string;
  /** Kullanıcının ne kaybettiğini anlatan cümle. */
  description: string;
  pending?: boolean;
  onConfirm: () => void;
}

export function WorkflowCancelDialog({
  open,
  onClose,
  title,
  description,
  pending = false,
  onConfirm,
}: WorkflowCancelDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onClose}>
            Vazgeç
          </Button>
          <Button
            type="button"
            variant="danger"
            loading={pending}
            disabled={pending}
            onClick={onConfirm}
            data-testid="akis-iptal-onayla"
          >
            İptal et
          </Button>
        </div>
      }
    >
      <p className="text-sm text-fg-muted">{description}</p>
    </Modal>
  );
}
